module.exports = __webpack_public_path__ + "media/images/power_limited_alert-f6a6927cd6d64bfc7c209a84203fdc23.svg";